import { useEffect, useState } from "react";
import { RotateCw, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/i18n/LanguageContext";
import { formatDate } from "@/modules/config";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export function FxWidget() {
  const { t } = useLang();
  const [fx, setFx] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = (refresh = false) => {
    setLoading(true);
    api.get("/fx/rates", { params: refresh ? { refresh: 1 } : {} })
      .then(({ data }) => setFx(data))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const usd = fx?.rates?.USD?.sell;
  const eur = fx?.rates?.EUR?.sell;
  if (usd == null && eur == null) return null;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid="fx-widget-btn"
          className="hidden md:flex items-center gap-1.5 text-xs text-slate-500 hover:text-blue-600 border border-slate-200 bg-white rounded-md px-2.5 py-1.5 transition-colors duration-150">
          <TrendingUp className="h-3.5 w-3.5 text-green-600" />
          {usd != null && <span className="tabular">$ {usd.toLocaleString("tr-TR", { minimumFractionDigits: 4 })}</span>}
          <span className="text-slate-300">·</span>
          {eur != null && <span className="tabular">€ {eur.toLocaleString("tr-TR", { minimumFractionDigits: 4 })}</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-72 p-4" data-testid="fx-widget-popover">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-[#0A1128]">{t("TCMB Efektif Satış")}</p>
          <button type="button" onClick={() => load(true)} disabled={loading} data-testid="fx-widget-refresh"
            aria-label={t("Yenile")} className="text-slate-400 hover:text-blue-600 transition-colors duration-150 disabled:opacity-50">
            <RotateCw className={`h-3.5 w-3.5 ${loading ? "animate-spin" : ""}`} />
          </button>
        </div>
        <div className="mt-3 space-y-1.5">
          {["USD", "EUR", "GBP", "CHF"].map((c) => fx?.rates?.[c] && (
            <div key={c} className="flex justify-between text-xs tabular" data-testid={`fx-widget-${c}`}>
              <span className="font-medium text-[#0A1128] w-10">{c}</span>
              <span className="text-slate-500">{t("Alış")} {fx.rates[c].buy.toLocaleString("tr-TR", { minimumFractionDigits: 4 })}</span>
              <span className="font-semibold text-green-700">{t("Satış")} {fx.rates[c].sell.toLocaleString("tr-TR", { minimumFractionDigits: 4 })}</span>
            </div>
          ))}
        </div>
        <p className="mt-3 text-[10px] text-slate-400">{fx?.date ? formatDate(fx.date) : ""} · TCMB</p>
      </PopoverContent>
    </Popover>
  );
}
